import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SvgComponent from '../../SvgComponent';
import { STATIC_ROOT } from '../../../constants';
import LinkButtonComponent from '../../button/LinkButtonComponent';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';
import {
    getMerchantCardUrl,
    displayableCashback,
    hasCashback,
    hasOffline,
    hasCashbackOffline,
    hasEbonCashback
} from '../../../services/partner/utils';
import { getBilletterieMerchantUrl } from '../../../services/billetterie/utils';
import { isBilletteriePartner } from '../../../services/billetterie/selector';

import './DiscoverOfferComponent.scss';

class DiscoverOfferComponent extends React.Component {
    shouldDisplayOnline = () => {
        const { partner, isOffline, isEbon } = this.props;
        return (isOffline || isEbon) && partner && hasCashback(partner);
    };
    shouldDisplayOffline = () => {
        const { partner, isOffline } = this.props;
        return !isOffline && partner && hasOffline(partner) && hasCashbackOffline(partner);
    };
    shouldDisplayEbon = () => {
        const { isEbon, ebonPartner } = this.props;
        return !isEbon && ebonPartner && hasEbonCashback(ebonPartner);
    };

    renderImage = (online, offline) => {
        if (online) {
            return (
                <SvgComponent
                    src={`${STATIC_ROOT}/picto-en-ligne.svg`}
                    width="48"
                    height="48"
                    aria-hidden="true"
                    focusable="false"
                />
            );
        } else if (offline) {
            return (
                <SvgComponent
                    src={`${STATIC_ROOT}/picto-magasin.svg`}
                    width="48"
                    height="48"
                    aria-hidden="true"
                    focusable="false"
                />
            );
        } else {
            return (
                <SvgComponent
                    src={`${STATIC_ROOT}/picto-ebon.svg`}
                    width="45"
                    height="34"
                    aria-hidden="true"
                    focusable="false"
                />
            );
        }
    };

    renderCashback = (online, offline, ebon, partnerDiscount, multiDiscount) => {
        const { i18n, partner } = this.props;

        const percent = !ebon ? partnerDiscount.percent : partnerDiscount.percent.value;
        const fixed = !ebon ? partnerDiscount.fixed : partnerDiscount.fixed.value;
        const initialPercent = !ebon
            ? partnerDiscount.initialPercent
            : partnerDiscount.percent.initialValue;
        const initialFixed = !ebon
            ? partnerDiscount.initialFixed
            : partnerDiscount.fixed.initialValue;

        const initialCashback = displayableCashback(initialPercent, initialFixed);

        const text = online ? i18n.ONLINE : offline ? i18n.OFFLINE : i18n.EBON_REFUND;

        return (
            <div>
                <span className="show-mobile">{this.renderImage(online, offline)}</span>
                {multiDiscount && `${i18n.jusqua} `}
                <span className="value">
                    {displayableCashback(percent, fixed)}{' '}
                    {online && partner.qwertys
                        ? i18n.IMMEDIATE_DISCOUNT
                        : ebon
                        ? i18n.offert
                        : i18n.rembourse}
                </span>
                &nbsp;{text}
                {initialCashback && (
                    <span className="olieu">
                        &nbsp;
                        {i18n.aulieude} {initialCashback}
                    </span>
                )}
            </div>
        );
    };

    renderBlock = (online, offline, ebon, discount, multiDiscount) => {
        const { i18n, partner, ebonPartner, isEbonBilletterie } = this.props;

        const buttonText = online ? i18n.ONLINE : offline ? i18n.OFFLINE : i18n.EBON;
        // L'offre bon d'achat d'un marchand billetterie se vend dans la zone billetterie
        const toBilletterie = ebon && isEbonBilletterie;
        const url = toBilletterie
            ? getBilletterieMerchantUrl(ebonPartner)
            : getMerchantCardUrl(partner, offline, ebon);

        return (
            <React.Fragment>
                <div className="discover-offer grid">
                    <div className="discover-offer-picto flex-container-h flex-center-alt hide-mobile">
                        {this.renderImage(online, offline)}
                    </div>
                    <div className="grid has-gutter flex-center-alt">
                        <div className="discover-offer-value">
                            {this.renderCashback(online, offline, ebon, discount, multiDiscount)}
                        </div>
                        <div className="discover-offer-bt one-half flex-container-v">
                            <LinkButtonComponent
                                color="fourth"
                                text={convertHtmlToReactDomWithParams(
                                    i18n.DISCOVER_OFFER,
                                    buttonText
                                )}
                                title={convertHtmlToReactDomWithParams(
                                    i18n.DISCOVER_OFFER,
                                    buttonText
                                )}
                                to={url}
                                external={toBilletterie}
                            />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    };

    render() {
        const { i18n, partner, ebonPartner } = this.props;

        return (
            <React.Fragment>
                {(this.shouldDisplayOnline() ||
                    this.shouldDisplayOffline() ||
                    this.shouldDisplayEbon()) && (
                    <React.Fragment>
                        <hr />
                        <h3>{i18n.DISCOVER_OFFER_TITLE}</h3>
                    </React.Fragment>
                )}
                {this.shouldDisplayOnline() &&
                    this.renderBlock(
                        true,
                        false,
                        false,
                        partner.mostDisplayableDiscountOnline,
                        partner.isMultiDiscount
                    )}
                {this.shouldDisplayOffline() &&
                    this.renderBlock(
                        false,
                        true,
                        false,
                        partner.mostDisplayableDiscountOffline,
                        partner.isMultiDiscountOffline
                    )}
                {this.shouldDisplayEbon() &&
                    this.renderBlock(false, false, true, ebonPartner.ebonDiscount.cashback, false)}
            </React.Fragment>
        );
    }
}

DiscoverOfferComponent.propTypes = {
    partner: PropTypes.object,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool,
    ebonPartner: PropTypes.object
};

const mapStoreToProps = (state, ownProps) => ({
    i18n: state.i18n.feature.partenaire,
    isEbonBilletterie: isBilletteriePartner(state, ownProps.ebonPartner && ownProps.ebonPartner.id)
});

export default connect(mapStoreToProps)(DiscoverOfferComponent);



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/DiscoverOfferComponent.js